import { ref } from 'vue';
import { trainingApi } from '@/entities/Training';
import { printPdfBlob, shouldUsePrintFallbackWindow, useCustomToast } from '@/shared/lib';

export const useTrainingControlPrint = () => {
  const { showErrorToast } = useCustomToast();
  const isGenerating = ref(false);

  async function printTrainingControl(id: number): Promise<void> {
    if (isGenerating.value) return;

    isGenerating.value = true;
    const fallbackWindow = shouldUsePrintFallbackWindow() ? window.open('', '_blank') : null;

    try {
      const blob = await trainingApi.getControlPdf(id);
      printPdfBlob(blob, fallbackWindow);
    } catch {
      fallbackWindow?.close();
      showErrorToast({
        title: 'Erro ao imprimir. Tente novamente',
        type: 'error',
      });
    } finally {
      isGenerating.value = false;
    }
  }

  return {
    isGenerating,
    printTrainingControl,
  };
};
